import React, { useState, useEffect, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { editUserAPI, editUser } from "../../api/user";
import swal from "sweetalert";
const initialState = {
  name: "",
  email: "",
  password: "",
  repassword: "",
  role_id: "",
  user_type: "",
  quota: "",
  created_by: "",
  published: "",
  dashboard_box: "",
  download_access: 0,
  daily_resume_download_limit: 0,
  daily_excel_download_limit: 0,
  lgbt_confirmed: 0,
  nonlgbt: 0,
  nonlgbt_man: 0,
  nonlgbt_woman: 0,
};

const EditUser = (props) => {
  const {
    editModal,
    setEditModal,
    menuData,
    dataFetch,
    editid,
    setEditContactId,
  } = props;
  const [updatePassword, setUpdatePassword] = useState(false);
  const [editFormData, setEditFormData] = useState(initialState);
  //const [dashboardBox, setDashboardBox] = useState([]);
  //console.log(editFormData);
  const updateFormData = useCallback(async () => {
    let formValues = await editUserAPI(editid);
    formValues.password = "";
    formValues.repassword = "";
    setEditFormData(formValues);
  }, [editid]);

  useEffect(() => {
    if (editid > 0) {
      updateFormData();
    }
  }, [editid, updateFormData]);

  const saveDashboardBox = useCallback((boxdata) => {
    const boxArray = boxdata.split(",");
    for (let index = 0; index < boxArray.length; index++) {
      document.querySelectorAll(
        'input[value="' + boxArray[index] + '"]'
      )[0].checked = true;
    }
  }, []);

  useEffect(() => {
    if (editFormData?.dashboard_box) {
      saveDashboardBox(editFormData?.dashboard_box);
    }
  }, [editFormData]);

  //update data function
  const handleEditFormChange = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;
    setEditFormData(newFormData);
  };

  // edit form data submit
  const handleEditFormSubmit = async (event) => {
    event.preventDefault();
    let editedContact = {};
    var error = false;
    var errorMsg = "";
    if (editFormData.name === "") {
      error = true;
      errorMsg = "Please fill User Name";
    } else if (editFormData.email === "") {
      error = true;
      errorMsg = "Please fill User Email";
    } else if (editFormData.password === "" && updatePassword === true) {
      error = true;
      errorMsg = "Please fill Password";
    } else if (editFormData.repassword === "" && updatePassword === true) {
      error = true;
      errorMsg = "Please fill Confirm Password";
    } else if (
      editFormData.password !== editFormData.repassword &&
      updatePassword === true
    ) {
      error = true;
      errorMsg = "Confirm password is not match with password";
    } else if (editFormData.role_id === "") {
      error = true;
      errorMsg = "Please select Role";
    } else if (editFormData.user_type === "2" && !editFormData.quota) {
      error = true;
      errorMsg = "Please enter quota";
    } else if (editFormData.user_type === "") {
      error = true;
      errorMsg = "Please select user type";
    } else if (
      editFormData.daily_resume_download_limit === undefined ||
      editFormData.daily_resume_download_limit === 0
    ) {
      error = true;
      errorMsg = "Please enter daily resume download quota";
    } else if (
      editFormData.daily_excel_download_limit === undefined ||
      editFormData.daily_excel_download_limit === 0
    ) {
      error = true;
      errorMsg = "Please enter daily excel export quota";
    }

    if (!error) {
      if (updatePassword === true) {
        editedContact = {
          name: editFormData.name,
          email: editFormData.email,
          password: editFormData.password,
          role_id: editFormData.role_id,
          status: editFormData.published,
          quota: editFormData.quota,
          user_type: editFormData.user_type,
          dashboard_box: editFormData.dashboard_box,
          download_access: editFormData?.download_access,
          resume_download_quota: editFormData?.resume_download_quota,
          daily_resume_download_limit:
            editFormData?.daily_resume_download_limit,
          daily_excel_download_limit: editFormData?.daily_excel_download_limit,
          lgbt_confirmed: editFormData.lgbt_confirmed,
          nonlgbt: editFormData.nonlgbt,
          nonlgbt_man: editFormData.nonlgbt_man,
          nonlgbt_woman: editFormData.nonlgbt_woman,
        };
      } else {
        editedContact = {
          name: editFormData.name,
          email: editFormData.email,
          role_id: editFormData.role_id,
          status: editFormData.published,
          quota: editFormData.quota,
          user_type: editFormData.user_type,
          dashboard_box: editFormData.dashboard_box,
          download_access: editFormData?.download_access,
          resume_download_quota: editFormData?.resume_download_quota,
          daily_resume_download_limit:
            editFormData?.daily_resume_download_limit,
          daily_excel_download_limit: editFormData?.daily_excel_download_limit,
          lgbt_confirmed: editFormData.lgbt_confirmed,
          nonlgbt: editFormData.nonlgbt,
          nonlgbt_man: editFormData.nonlgbt_man,
          nonlgbt_woman: editFormData.nonlgbt_woman,
        };
      }
      await editUser(editedContact, editid);
      dataFetch(true);
      setEditContactId(null);
      setEditFormData(initialState);
      setUpdatePassword(false);
      setEditModal(false);
      swal("Successfully Updated User!", "Successfully Updated", "success");
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const handleCheckBoxes = useCallback(
    (e) => {
      const data = [
        ...document.querySelectorAll('input[name="dashboard_box"]:checked'),
      ].map((e) => e.value);
      setEditFormData((pre) => ({ ...pre, dashboard_box: data.join(",") }));
    },
    [setEditFormData]
  );

  const handleAccessType = useCallback(
    (e, className) => {
      const data = {};
      const inputs = document.getElementsByClassName(className);
      for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        if (input.type === "checkbox" || input.type === "radio") {
          if (input.checked) {
            data[input.name] = 1;
          } else {
            if (input.name == "nonlgbt") {
              data["nonlgbt_man"] = 0;
              data["nonlgbt_woman"] = 0;
            }
            data[input.name] = 0;
          }
        } else {
          data[input.name] = 1;
        }
      }
      setEditFormData((pre) => ({ ...pre, ...data }));
    },
    [setEditFormData]
  );

  const handleDownloadAccessCheckBoxes = useCallback(
    (e) => {
      setEditFormData((pre) => ({
        ...pre,
        download_access: e.target.checked ? 1 : 0,
      }));
    },
    [setEditFormData]
  );

  return (
    <>
      <Modal
        className="modal fade bd-example-modal-lg"
        show={editModal}
        onHide={setEditModal}
        centered
        size="lg"
      >
        <div role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <h4 className="modal-title fs-20">Update User</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditModal(false)}
                  data-dismiss="modal"
                >
                  <span></span>
                </button>
              </div>
              <div className="modal-body">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-12">
                          <label className="text-black font-w500 mt-2">
                            Username <span className="text-danger">*</span>{" "}
                          </label>
                          <div className="contact-name">
                            <input
                              type="text"
                              className="form-control"
                              autoComplete="off"
                              name="name"
                              required="required"
                              value={editFormData?.name}
                              onChange={handleEditFormChange}
                              placeholder="Enter User Name"
                            />
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-12">
                          <label className="text-black font-w500 mt-2">
                            User Email <span className="text-danger">*</span>
                          </label>
                          <div className="contact-name">
                            <input
                              type="text"
                              className="form-control"
                              autoComplete="off"
                              name="email"
                              value={editFormData?.email}
                              required="required"
                              onChange={handleEditFormChange}
                              placeholder="Enter User Email Address"
                            />
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group mb-6">
                      <label className="text-black font-w500 mt-2">
                        Do you want to change Password?
                      </label>
                      <div className="contact-name">
                        <div className="form-group mb-0">
                          <label className="radio-inline me-3">
                            <input
                              type="radio"
                              name="optradio"
                              defaultChecked={updatePassword === true}
                              onClick={() => setUpdatePassword(true)}
                            />{" "}
                            Yes
                          </label>
                          <label className="radio-inline me-3">
                            <input
                              type="radio"
                              name="optradio"
                              defaultChecked={updatePassword === false}
                              onClick={() => setUpdatePassword(false)}
                            />{" "}
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    {updatePassword ? (
                      <>
                        <div className="form-group mb-6">
                          <div className="row">
                            <div className="form-group mb-6 col-md-12">
                              <label className="text-black font-w500 mt-2">
                                Password <span className="text-danger">*</span>
                              </label>
                              <div className="contact-name">
                                <input
                                  type="password"
                                  className="form-control"
                                  autoComplete="off"
                                  name="password"
                                  required="required"
                                  onChange={handleEditFormChange}
                                  placeholder="Enter Password"
                                />
                                <span className="validation-text"></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-group mb-6">
                          <div className="row">
                            <div className="form-group mb-6 col-md-12">
                              <label className="text-black font-w500 mt-2">
                                Confirm Password{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <div className="contact-name">
                                <input
                                  type="password"
                                  className="form-control"
                                  autoComplete="off"
                                  name="repassword"
                                  required="required"
                                  onChange={handleEditFormChange}
                                  placeholder="Enter Confirm Password"
                                />
                                <span className="validation-text"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-12">
                          <label className="text-black font-w500 mt-2">
                            Select Role <span className="text-danger">*</span>
                          </label>
                          <div className="contact-name">
                            <select
                              className="form-select"
                              id="role_id"
                              name="role_id"
                              onChange={handleEditFormChange}
                              value={editFormData?.role_id}
                            >
                              <option value="">Please select</option>
                              {menuData?.map((item, index) => {
                                return (
                                  <option value={item.id} key={index}>
                                    {item.role_name}
                                  </option>
                                );
                              })}
                            </select>
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-12">
                          <label className="text-black font-w500 mt-2">
                            User Type <span className="text-danger">*</span>
                          </label>
                          <div className="contact-name">
                            <select
                              className="form-select"
                              id="user_type"
                              name="user_type"
                              onChange={handleEditFormChange}
                              value={editFormData?.user_type}
                              //defaultValue={editFormData?.user_type}
                            >
                              <option value="">Select User Type</option>
                              <option value="1">Admin</option>
                              <option value="2">Editor</option>
                            </select>
                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {editFormData.user_type === "2" && (
                      <>
                        <div className="form-group">
                          <label className="text-black font-w500 mt-2">
                            Access type
                          </label>
                          <div className="contact-name">
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input access_type"
                                type="checkbox"
                                name="lgbt_confirmed"
                                value="1"
                                id="lgbt_confirmed"
                                onChange={(e) =>
                                  handleAccessType(e, "access_type")
                                }
                                defaultChecked={
                                  editFormData?.lgbt_confirmed === 1
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="lgbt_confirmed"
                              >
                                LGBT Confirmed
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input access_type"
                                type="checkbox"
                                name="nonlgbt"
                                value="1"
                                id="nonlgbt"
                                onChange={(e) =>
                                  handleAccessType(e, "access_type")
                                }
                                defaultChecked={editFormData?.nonlgbt === 1}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="nonlgbt"
                              >
                                Non LGBT+
                              </label>
                            </div>
                            {editFormData.nonlgbt === 1 && (
                              <>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input access_type"
                                    type="checkbox"
                                    name="nonlgbt_man"
                                    value="1"
                                    id="nonlgbt_man"
                                    onChange={(e) =>
                                      handleAccessType(e, "access_type")
                                    }
                                    defaultChecked={
                                      editFormData?.nonlgbt_man === 1
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="nonlgbt_man"
                                  >
                                    Man
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input access_type"
                                    type="checkbox"
                                    name="nonlgbt_woman"
                                    value="1"
                                    id="nonlgbt_woman"
                                    onChange={(e) =>
                                      handleAccessType(e, "access_type")
                                    }
                                    defaultChecked={
                                      editFormData?.nonlgbt_woman === 1
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="nonlgbt_woman"
                                  >
                                    Woman
                                  </label>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        <div className="form-group mb-6">
                          <div className="row">
                            <div className="form-group mb-6 col-md-12">
                              <label className="text-black font-w500 mt-2">
                                Unlock Quota (per month)
                                <span className="text-danger">*</span>
                              </label>
                              <div className="contact-name">
                                <input
                                  type="number"
                                  className="form-control"
                                  autoComplete="off"
                                  name="quota"
                                  id="quota"
                                  required="required"
                                  onChange={handleEditFormChange}
                                  placeholder="Unlock Quota"
                                  defaultValue={editFormData?.quota}
                                />
                                <span className="validation-text"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="form-group">
                      <label className="text-black font-w500 mt-2">
                        Dashboard Summary Box
                      </label>
                      <div className="contact-name">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="dashboard_box"
                            value="AAP"
                            id="all_applicants"
                            //checked={true}
                            onChange={handleCheckBoxes}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="all_applicants"
                          >
                            All Applicants
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="dashboard_box"
                            value="RCT"
                            id="recruiters"
                            onChange={handleCheckBoxes}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="recruiters"
                          >
                            Recruiters
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="dashboard_box"
                            value="JOB"
                            id="jobs"
                            onChange={handleCheckBoxes}
                          />
                          <label className="form-check-label" htmlFor="jobs">
                            Jobs
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="dashboard_box"
                            value="EDT"
                            id="editor"
                            onChange={handleCheckBoxes}
                          />
                          <label className="form-check-label" htmlFor="editor">
                            Editor
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="dashboard_box"
                            value="SKL"
                            id="skills"
                            onChange={handleCheckBoxes}
                          />
                          <label className="form-check-label" htmlFor="skills">
                            Skills
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="dashboard_box"
                            value="LOC"
                            id="locations"
                            onChange={handleCheckBoxes}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="locations"
                          >
                            Locations
                          </label>
                        </div>
                        <span className="validation-text"></span>
                      </div>
                    </div>

                    <div className="form-group">
                      <label
                        className="text-black font-w500 mt-2"
                        htmlFor="download_access"
                      >
                        Download Access
                        <input
                          className="form-check-input ms-2"
                          type="checkbox"
                          name="download_access"
                          //value="1"
                          id="download_access"
                          checked={
                            editFormData?.download_access === 1 ? true : false
                          }
                          onChange={handleDownloadAccessCheckBoxes}
                        />
                      </label>
                    </div>

                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-6">
                          <label className="text-black font-w500 mt-2">
                            Daily Resume download quota
                            <span className="text-danger">*</span>
                          </label>
                          <div className="contact-name">
                            <input
                              type="number"
                              className="form-control"
                              autoComplete="off"
                              name="daily_resume_download_limit"
                              id="daily_resume_download_limit"
                              required="required"
                              onChange={handleEditFormChange}
                              placeholder="Daily Resume download quota"
                              // defaultValue={
                              //   editFormData?.daily_resume_download_limit
                              // }
                              value={editFormData?.daily_resume_download_limit}
                            />

                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mb-6">
                      <div className="row">
                        <div className="form-group mb-6 col-md-6">
                          <label className="text-black font-w500 mt-2">
                            Daily excel download quota
                            <span className="text-danger">*</span>
                          </label>
                          <div className="contact-name">
                            <input
                              type="number"
                              className="form-control"
                              autoComplete="off"
                              name="daily_excel_download_limit"
                              id="daily_excel_download_limit"
                              required="required"
                              onChange={handleEditFormChange}
                              placeholder="Daily excel download quota"
                              value={editFormData?.daily_excel_download_limit}
                            />

                            <span className="validation-text"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mb-3">
                      <label className="text-black font-w500 mt-2">
                        Status
                      </label>
                      <div className="contact-name">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="published"
                          value="1"
                          id="statusActive"
                          checked={editFormData?.published === "1"}
                          onChange={handleEditFormChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="statusActive"
                        >
                          Active
                        </label>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="published"
                          value="0"
                          checked={editFormData?.published === "0"}
                          id="statusInactive"
                          onChange={handleEditFormChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="statusInactive"
                        >
                          InActive
                        </label>
                        <span className="validation-text"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-success"
                  onClick={handleEditFormSubmit}
                >
                  Update
                </button>
                <button
                  type="button"
                  onClick={() => setEditModal(false)}
                  className="btn btn-danger"
                >
                  <i className="flaticon-delete-1"></i> Discard
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default EditUser;
